import {
    QUESTION_TYPE,
    TAB_FLAG,
    TASK_STATUS,
    RECEIVE_METHOD,
} from 'Utils/constant';
export default {
    isString(str) {
        return typeof str === 'string' ? true : false;
    },
    isNumber(num) {
        return typeof num === 'number' ? true : false;
    },
    isBoolean(bool) {
        return typeof bool === 'boolean' ? true : false;
    },
    isFunction(fn) {
        return typeof fn === 'function' ? true : false;
    },
    isNaN(num) {
        return window.isNaN(num);
    },
    isArray(arr) {
        return arr instanceof Array ? true : false;
    },
    isDate(date) {
        return date instanceof Date ? true : false;
    },
    isDom(dom) {
        return dom instanceof Element ? true : false;
    },

    getClassName(obj) {
        if (this.isString(obj)) {
            return obj;
        }
        if (this.isArray(obj)) {
            return obj.join(' ');
        }
        try {
            if (
                !this.isArray(obj) &&
                !this.isFunction(obj) &&
                typeof obj === 'object'
            ) {
                let classNameList = [];

                Object.keys(obj).forEach((item) => {
                    if (obj[item]) {
                        classNameList.push(item);
                    }
                });

                return classNameList.join(' ');
            }
        } catch (err) {
            throw new Error(err);
        }
    },

    dateFilter(date, type) {
        let temp = type;
        date = new Date(date);

        temp = temp.replace(/y{4}/, date.getFullYear());
        temp = temp.replace(/y{2}/, ('' + date.getFullYear()).substring(2));
        temp = temp.replace(/M{2}/, makeZero(date.getMonth() + 1, 2));
        temp = temp.replace(/d{2}/, makeZero(date.getDate(), 2));
        temp = temp.replace(/h{2}/, makeZero(date.getHours(), 2));
        temp = temp.replace(/m{2}/, makeZero(date.getMinutes(), 2));
        temp = temp.replace(/s{2}/, makeZero(date.getSeconds(), 2));
        temp = temp.replace(/S{3}/, makeZero(date.getMilliseconds(), 3));

        function makeZero(num, length) {
            num += '';

            for (let i = num.length; i < length; i++) {
                num = '0' + num;
            }

            return num;
        }

        return temp;
    },

    isPhone() {
        let system = window.navigator.userAgent.toUpperCase();

        return /(ANDROID|IPHONE|IOS)/.test(system) ? true : false;
    },

    isAndroid() {
        let system = window.navigator.userAgent.toUpperCase();

        return /ANDROID/.test(system) ? true : false;
    },

    isIOS() {
        let system = window.navigator.userAgent.toUpperCase();

        return /(IPHONE|IOS)/.test(system) ? true : false;
    },

    clickOfSingleTap(
        callback,
        options = {isPreventDefault: false, isStopPropagation: false},
    ) {
        if (this.isPhone()) {
            return {
                onTouchStart: (ev) => {
                    let moved = false;
                    let event = ev.nativeEvent;
                    if (ev.touches.length !== 1) return;

                    options.isPreventDefault === true && ev.preventDefault();
                    options.isStopPropagation === true && ev.stopPropagation();

                    let touchmove = (ev) => {
                        moved = true;
                    };
                    let touchend = () => {
                        if (moved) return;

                        if (typeof callback === 'function')
                            window.setTimeout(() => callback(event), 300);
                    };

                    document.addEventListener('touchmove', touchmove, {
                        once: true,
                    });
                    document.addEventListener('touchend', touchend, {
                        once: true,
                    });
                },
            };
        } else {
            return {
                onClick: (ev) => {
                    options.isPreventDefault === true && ev.preventDefault();
                    options.isStopPropagation === true && ev.stopPropagation();
                    if (typeof callback === 'function') callback(ev);
                },
            };
        }
    },

    mouseOfSingleTap(
        callback,
        options = {isPreventDefault: false, isStopPropagation: false},
    ) {
        if (this.isPhone()) {
            return {
                onTouchStart: (ev) => {
                    let moved = false;
                    let event = ev.nativeEvent;
                    if (ev.touches.length !== 1) return;

                    options.isPreventDefault === true && ev.preventDefault();
                    options.isStopPropagation === true && ev.stopPropagation();

                    let touchmove = (ev) => {
                        moved = true;
                    };
                    let touchend = () => {
                        if (moved) return;

                        if (typeof callback === 'function')
                            window.setTimeout(() => callback(event), 300);
                    };

                    document.addEventListener('touchmove', touchmove, {
                        once: true,
                    });
                    document.addEventListener('touchend', touchend, {
                        once: true,
                    });
                },
            };
        } else {
            return {
                onMouseDown: (ev) => {
                    options.isPreventDefault === true && ev.preventDefault();
                    options.isStopPropagation === true && ev.stopPropagation();
                    if (typeof callback === 'function') callback(ev);
                },
            };
        }
    },

    toMoney(num, noRound) {
        num = parseFloat(num);
        if (!noRound) {
            num = (Math.round(num * 100) / 100).toFixed(2);
        }
        num = num.toLocaleString();
        return num;
    },

    getScreenSize() {
        let width = null;
        let height = null;

        if (document.documentElement) {
            width = document.documentElement.clientWidth;
            height = document.documentElement.clientHeight;
        } else if (document.body) {
            width = document.body.clientWidth;
            height = document.body.clientHeight;
        }

        return {width, height};
    },

    getScrollPos() {
        let scrollTop = 0;
        let scrollLeft = 0;

        if (this.isNumber(window.pageYOffset)) {
            scrollTop = window.pageYOffset;
            scrollLeft = window.pageXOffset;
        } else if (document.documentElement) {
            scrollTop = document.documentElement.scrollTop;
            scrollLeft = document.documentElement.scrollLeft;
        } else if (document.body) {
            scrollTop = document.body.scrollTop;
            scrollLeft = document.body.scrollLeft;
        }

        return {top: scrollTop, left: scrollLeft};
    },
    setScrollPos(pos) {
        if (document.documentElement) {
            document.documentElement.scrollTop = pos.top;
            document.documentElement.scrollLeft = pos.left;
        } else if (document.body) {
            document.body.scrollTop = pos.top;
            document.body.scrollLeft = pos.left;
        }
    },
    getElementPos(ele) {
        let pos = {
            left: 0,
            top: 0,
        };

        while (ele) {
            pos.left += ele.offsetLeft;
            pos.top += ele.offsetTop;
            ele = ele.offsetParent;
        }

        return pos;
    },
    // Get The Image Root Url
    getImageRoot(url) {
        let prefix = '';

        if (!url || url.indexOf('http') === -1) {
            prefix = '';
        }

        return prefix;
    },
    // Format Address
    formatAddress(city = '', address = '', building = '') {
        let formatAddress = '';
        let cityArray = [];

        city = city ? city : '';
        address = address ? address : '';
        building = building ? building : '';
        try {
            cityArray = city.split('-');

            if (cityArray[1].indexOf(cityArray[0]) !== -1) {
                formatAddress = cityArray[1] + address + building;
            } else {
                formatAddress = cityArray.join('') + address + building;
            }

            return formatAddress;
        } catch (err) {
            return city + ' ' + address + ' ' + building;
        }
    },
    // Format Address
    formatStAddress(city = '', address = '', building = '', stDepartment = '') {
        let formatAddress = '';
        let cityArray = [];

        city = city ? city : '';
        address = address ? address : '';
        building = building ? building : '';
        try {
            cityArray = city.split('-');

            if (cityArray[1].indexOf(cityArray[0]) !== -1) {
                formatAddress =
                    cityArray[1] + address + building + stDepartment;
            } else {
                formatAddress =
                    cityArray.join('') + address + building + stDepartment;
            }

            return formatAddress;
        } catch (err) {
            return city + ' ' + address + ' ' + building + ' ' + stDepartment;
        }
    },
    getComputedStyle(element, styleName) {
        let style = null;

        if (this.isFunction(window.getComputedStyle)) {
            style = window.getComputedStyle(element)[styleName];
        }
        if (element.currentStyle) {
            style = element.currentStyle[styleName];
        }

        return style ? style : 'none';
    },
    formateContactId(phoneNum) {
        let num;

        if (phoneNum) {
            num = phoneNum
                .replace(/\+86/g, '')
                .replace(/[\+\(\)\-\x\?\s]/g, '');
        } else {
            num = phoneNum;
        }

        return num;
    },

    addShoppingCartAnimation(params) {
        const img = new Image();
        const imgWrap = document.createElement('div');
        const imgWrap2 = document.createElement('div');
        const shoppingCartBtn = params.shoppingCartBtn;
        const clientX = params.clientX;
        const clientY = params.clientY;
        const animationTime = params.animationTime;

        // animation start position.
        imgWrap.style.position = 'fixed';
        imgWrap.style.zIndex = 10;
        imgWrap.style.top = clientY + 'px';
        imgWrap.style.left = clientX + 'px';
        imgWrap.style.transition = `top ${animationTime}ms cubic-bezier(0, 0.69, 0.55, 1.32)`;

        imgWrap2.style.width = '2rem';
        imgWrap2.style.height = '2rem';
        imgWrap2.style.borderRadius = '50%';
        imgWrap2.style.overflow = 'hidden';
        imgWrap2.style.position = 'relative';
        imgWrap2.style.left = 0;
        imgWrap2.style.transition = `${animationTime}ms linear`;
        imgWrap2.style.transitionProperty = 'left, width, height, transform';

        img.onload = function () {
            if (img.width > img.height) {
                img.style.height = '100%';
            } else {
                img.style.width = '100%';
            }
            img.style.position = 'absolute';
            img.style.left = '50%';
            img.style.top = '50%';
            img.style.transform = 'translate(-50%, -50%)';
        };
        // img.src = this.getImageRoot() + 'pic/Upload/Products/NoImage.jpg';
        img.src = new URL('Images/shopping_image.png', import.meta.url).href;

        imgWrap2.appendChild(img);
        imgWrap.appendChild(imgWrap2);
        document.getElementsByTagName('body')[0].appendChild(imgWrap);

        // animation end position.
        window.setTimeout(() => {
            imgWrap.style.top = this.getElementPos(shoppingCartBtn).top + 'px';
            if (
                this.getComputedStyle(
                    document.getElementById('header-container'),
                    'transform',
                ) !== 'none'
            ) {
                imgWrap2.style.left =
                    this.getElementPos(shoppingCartBtn).left -
                    clientX -
                    220 +
                    'px';
            } else {
                imgWrap2.style.left =
                    this.getElementPos(shoppingCartBtn).left - clientX + 'px';
            }

            window.setTimeout(() => {
                document.getElementsByTagName('body')[0].removeChild(imgWrap);
            }, animationTime);
        });
    },

    getShipToNumber(localData) {
        let shipToNum = localData.shipToNum;
        if (
            typeof localData.temporaryShipToNumber !== 'undefined' &&
            localData.temporaryShipToNumber !== ''
        ) {
            shipToNum = localData.temporaryShipToNumber;
        }
        return shipToNum;
    },

    getSCdata(localData) {
        let scData = {
            scId: localData.scId,
            scName: localData.scName,
            scType: localData.scType,
        };

        return scData;
    },

    getPropertyExistsAndIsTrue(currentProperty) {
        if (currentProperty !== 'undefined' && currentProperty) {
            return true;
        } else {
            return false;
        }
    },

    getActionField(sendParams) {
        let actionField = {};
        if (
            sendParams.triggerType === 'Product click' ||
            sendParams.triggerType === 'Product detail' ||
            sendParams.triggerType === 'Add to cart'
        ) {
            actionField = {
                list: sendParams.pageType,
            };
        } else if (sendParams.triggerType === 'Submit order') {
            actionField = {
                step: '1',
            };
        } else if (sendParams.triggerType === 'Submit shipment') {
            actionField = {
                step: '2',
            };
        }
        return actionField;
    },
    getLockedType(item) {
        let lockType = item.lockType;
        let locked = '';
        if (
            !(lockType || lockType === 'null') ||
            lockType === 'unLock' ||
            lockType === 'No'
        ) {
            locked = 'noLocked';
        } else if (
            lockType.indexOf('C1') !== -1 ||
            lockType.indexOf('C2') !== -1
        ) {
            if (lockType.indexOf('adding_C2') !== -1) {
                locked = 'addingC2Locked';
            } else {
                locked = 'financialLocked';
            }
        } else if (
            lockType.indexOf('checking') !== -1 ||
            lockType.indexOf('checking_others') !== -1
        ) {
            locked = 'checking';
        } else {
            locked = 'checking';
        }
        return locked;
    },
    getUploadType(uploadMethod) {
        if (uploadMethod === RECEIVE_METHOD.CUSTOMER) {
            return 'receipt';
        } else if (uploadMethod === RECEIVE_METHOD.DELEGATE) {
            return 'location_image';
        } else {
            return '';
        }
    },
    getLockedTypeMessage(item) {
        let notification_message = '';
        if (
            item.lockType.indexOf('C1') !== -1 ||
            item.lockType.indexOf('C2') !== -1 ||
            item.lockType.indexOf('adding_C2') !== -1
        ) {
            notification_message = 'notification_order_c1_and_c2_locked';
        } else if (item.lockType.indexOf('ED') !== -1) {
            notification_message = 'notification_order_ed_locked';
        } else {
            notification_message = 'notification_order_other_locked';
        }
        return notification_message;
    },
    getb2bCasmatShipmentMessage(item) {
        let notification_message = '';
        if (item.b2bShipmentFlag === 'Y') {
            notification_message = 'shippment_b2b_shipping_order_message';
        } else {
            notification_message = 'notification_order_other_locked';
        }
        return notification_message;
    },
    getRouterState(locationState) {
        let routerState = '';
        if (locationState) {
            routerState = locationState;
        }
        return routerState;
    },
    isWechatBrowser() {
        var userAgentBrowser = navigator.userAgent.toLowerCase();
        if (userAgentBrowser.indexOf('micromessenger') !== -1) {
            return true;
        } else {
            return false;
        }
    },
    getPurchaseOrderMode() {
        let orderMode = '';
        if (localStorage.getItem('ltoPurchaseOrderMode')) {
            orderMode = localStorage.getItem('ltoPurchaseOrderMode');
        }
        return orderMode;
    },
    getPurchaseCustomerEmail() {
        let customerEmail = '';
        if (localStorage.getItem('purchaseCustomerEmail')) {
            customerEmail = localStorage.getItem('purchaseCustomerEmail');
        }
        return customerEmail;
    },
    getPurchaseCustomerName() {
        let customerName = '';
        if (localStorage.getItem('purchaseCustomerName')) {
            customerName = localStorage.getItem('purchaseCustomerName');
        }
        return customerName;
    },
    isExistenceProperty(propertyName) {
        let isExistFlag = false;
        if (typeof propertyName !== 'undefined' && propertyName) {
            isExistFlag = true;
        }

        return isExistFlag;
    },
    getMaxFileSize(fileLimits) {
        let limit = fileLimits ? fileLimits.split('limit') : '';
        return limit && limit.length > 1 ? limit[1] : '20M';
    },

    getPhoneNumberArr(receiverItem) {
        let resendNotificationData = [];
        let tempPhoneNumberArr = receiverItem.receiver
            ? receiverItem.receiver.split(',')
            : '';
        tempPhoneNumberArr.length > 0 &&
            tempPhoneNumberArr.map((tempPhoneItem, tempPhoneIndex) => {
                resendNotificationData.push({
                    id: ++tempPhoneIndex,
                    name: tempPhoneItem,
                });
            });

        return resendNotificationData;
    },

    showCancelledOrderStatus(cancelBy) {
        let displayOrderStatus = 'lto_history_detail_order_timeout';
        if (cancelBy === 'customer') {
            displayOrderStatus = 'lto_history_detail_customer_cancel';
        } else if (cancelBy === 'sc_proxy') {
            displayOrderStatus = 'lto_history_detail_order_revoke';
        } else if (cancelBy === 'timeout') {
            displayOrderStatus = 'lto_history_detail_order_timeout';
        }

        return displayOrderStatus;
    },

    isRequireSubmit(shippingPlanModalComps) {
        let shippingPlanCount = 0;
        let requireSubmit = true;
        if (shippingPlanModalComps && shippingPlanModalComps.length > 0) {
            shippingPlanModalComps.map((planItem) => {
                if (typeof planItem.id !== 'undefined' && planItem.id) {
                    ++shippingPlanCount;
                }
            });
        }

        if (shippingPlanCount === shippingPlanModalComps.length) {
            requireSubmit = false;
        }

        return requireSubmit;
    },
    getShippingPlanParam(shippingPlanModalComps) {
        let shippingPlanArr = [];
        if (shippingPlanModalComps && shippingPlanModalComps.length > 0) {
            shippingPlanModalComps.map((planItem, planIndex) => {
                let obj = new Object();
                if (planItem.shippingDate && planItem.quantity) {
                    obj = {
                        shippingDate: planItem.shippingDate,
                        quantity: planItem.quantity,
                        remark: planItem.remark ? planItem.remark.trim() : '',
                    };
                    if (typeof planItem.id !== 'undefined') {
                        obj.id = planItem.id;
                    }

                    shippingPlanArr.push(obj);
                }
            });
        }

        return shippingPlanArr;
    },
    isShippingDateNull(shippingPlanModalComps) {
        let shippingPlanObj = {
            isQuantityFlag: false,
            isShippingDateFlag: false,
        };

        if (shippingPlanModalComps && shippingPlanModalComps.length > 0) {
            shippingPlanModalComps.map((planItem, planIndex) => {
                if (!planItem.quantity || planItem.quantity === 0) {
                    shippingPlanObj.isQuantityFlag = true;
                } else if (!planItem.shippingDate) {
                    shippingPlanObj.isShippingDateFlag = true;
                }
            });
        }

        return shippingPlanObj;
    },

    updateCurrentShippingPlanFlag(currentOrderProduct, myOrderData) {
        let currentMyOrderData = JSON.parse(JSON.stringify(myOrderData));
        if (
            currentMyOrderData &&
            currentMyOrderData.orderProducts &&
            currentMyOrderData.orderProducts.length > 0
        ) {
            currentMyOrderData.orderProducts.map((orderProductItem) => {
                if (orderProductItem.id === currentOrderProduct.id) {
                    orderProductItem.haveShippingPlan = true;
                }
            });
        }
        return currentMyOrderData;
    },
    getNoPermissionSkuDevision(err) {
        let devisionValue = '';
        if (
            err &&
            err.data &&
            err.data.skuDivisions &&
            err.data.skuDivisions.length > 0
        ) {
            let skuDivisionsList = err.data.skuDivisions;
            devisionValue = skuDivisionsList.join();
        }

        return devisionValue;
    },

    isDisabledQuestion(tabFlag, taskStatus) {
        let disabledFlag = false;
        if (
            (tabFlag && tabFlag === TAB_FLAG.ALL_COMPLETED) ||
            (tabFlag === TAB_FLAG.FOLLOW_UP &&
                taskStatus === TASK_STATUS.SUBMITTED)
        ) {
            disabledFlag = true;
        }

        return disabledFlag;
    },
    isShowBtn(orderProducts) {
        let result = true;
        for (const item of orderProducts) {
            if (item.product.erpType === 'Global_E1_FSBIO') {
                result = false;
                break;
            }
        }
        return result;
    },
    getLockedTypeOriginalValue(lockType) {
        const lowerValue = lockType && String(lockType).trim().toLowerCase();
        if (
            !lockType ||
            lowerValue === 'null' ||
            lowerValue === 'unlock' ||
            lowerValue === 'no'
        ) {
            return '';
        }
        return lockType;
    },
};
